import { gql } from 'graphql-request'

const GET_SEARCH_HIGHEST_PRICE = gql`
  query getProductsHighestPrice($search: String) {
    prices(
      limit: 1
      order_by: { price_subunit: desc }
      where: {
        _or: [
          {
            product: {
              _and: {
                _or: [
                  { name: { _ilike: $search } }
                  { creator: { nickname: { _ilike: $search } } }
                ]
                creator: { account_status: { _eq: "active" } }
                status: { _eq: "active" }
                visible: { _eq: "true" }
                _not: { type: { _eq: "Product::FansiForBrands" } }
              }
            }
          }
          {
            price_contest_entry: {
              product: {
                _and: {
                  _or: [
                    { name: { _ilike: $search } }
                    { creator: { nickname: { _ilike: $search } } }
                  ]
                  creator: { account_status: { _eq: "active" } }
                  status: { _eq: "active" }
                  visible: { _eq: "true" }
                }
              }
            }
          }
        ]
      }
    ) {
      value: price_subunit
    }
  }
`

export default GET_SEARCH_HIGHEST_PRICE
